// extracted by mini-css-extract-plugin
export default {"root":"EditInstanceConfigForm_root__Uwd1I","form":"EditInstanceConfigForm_form__9-nKX","after":"EditInstanceConfigForm_after__fSifI"};